import JSX, {h, Component} from 'preact'
import SearchBox from "../search-box/SearchBox";
import Fetch from "../selector/Fetch";
import Icon from "../assets";

interface Props {
  header?: {
    title: JSX.Element,
    onClick: () => void
  },
  hasSearch?: boolean,
  isDynamic?: boolean,
  fetchUrl?: string,
  onLoad?: Function,
  placeholder?: string,
  children: JSX.Element
}

interface State {
  data: any[],
  fetchedItems: any[],
  value?: string
}

class ListSelector extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      data: [],
      fetchedItems: [],
      value: undefined
    }
  }

  render ({ header, hasSearch, isDynamic, fetchUrl, onLoad, placeholder, children }: Props, { data, value }: State) {
    return <div class='list-selector-wrapper'>
      <div class='list-selector list-selector-right'>
        { header && <div class='list-selector-header' onClick={header.onClick}>{header.title}</div>}
      { hasSearch && <SearchBox
          isModerationOverview
          placeholder={placeholder}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({value: (e.target as HTMLInputElement).value})}
          onClear={() => this.setState({ value: '' })}
      />}
      {isDynamic ? <Fetch baseUrl={fetchUrl || ''} searchValue={value || ''} onLoaded={onLoad || function() {}}>
        {({loading, items}: { loading: boolean, items: any[] }) => {
          if (loading) return <div className='loader'><Icon icon='loader'/></div>
          if(!loading && items.length === 0) return <div className='list-selector-no-results'>No results found</div>
          return children[0](items)
        }
        }
      </Fetch> : children}
      </div>
    </div>
  }
}

export default ListSelector
